module.exports = __webpack_public_path__ + "img/KR.fbae2004.png";